import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type { SingleBoardNodesResponse } from 'types/BoardNode';
import { generateAppendQueryParam } from 'utilities/hooks/urlGeneration';

type MutationVariables = { boardNodeID: string | null | undefined };

export function useDuplicateBoardNode(boardID: String | null | undefined) {
  const queryClient = useQueryClient();

  const addDuplicateBoard = async ({ boardNodeID }: MutationVariables) => {
    if (!boardNodeID) {
      return Promise.reject('Board Node ID cannot be null');
    }

    const body = {
      data: {
        id: boardNodeID,
        type: SPARK_RESOURCE_TYPES.BOARD_NODES,
      },
    };

    return fetchWrapper<SingleBoardNodesResponse>({
      url: `${
        SPARK_RESOURCE_TYPES.BOARD_NODES
      }/${boardNodeID}/duplicate?${generateAppendQueryParam(
        'includeData',
        true
      )}`,
      method: 'POST',
      body,
    });
  };

  return useMutation('duplicateBoardNode', addDuplicateBoard, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to Duplicate Board Node: ${error.message}`);
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries([
        SPARK_RESOURCE_TYPES.BOARD_NODES,
        boardID,
      ]);
    },
  });
}
